
import useAxiosPrivate from "./useAxiosPrivate";
import { useDispatch, useSelector } from "react-redux";
import { getGiftSkuList  } from "../slice/skuSlice";

const useGiftSkuList = () => {
  const getDropDownData = useSelector((state) => state.app.curretDropdownData);
  const Axios = useAxiosPrivate();
  const dispatch = useDispatch();
  const getAllGiftSkuList = async () => {
    const param = {
      zone_id: getDropDownData?.zone_id,
    }
    const response = await Axios.post("/gift_sku_list", param);
    const data = await response.data;
    dispatch(getGiftSkuList(data.giftSkuList));
    
  };

   return getAllGiftSkuList;

};

export default useGiftSkuList;
